const HorizontalRule = () => <hr className="bg-current" />

export default HorizontalRule
